import { isValidDateString } from '@/common/utils/dateValidator'
import { z } from 'zod'

export const extendGovernmentAllocationSchema = z.object({
  requested_new_end_date: z
    .string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' }),
})

export type ExtendGovernmentAllocationSchema = z.infer<typeof extendGovernmentAllocationSchema>
